import { render, staticRenderFns } from "./r-cell-config-table.vue?vue&type=template&id=1f5b8a2a"
import script from "./r-cell-config-table.vue?vue&type=script&lang=js"
export * from "./r-cell-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5b8a2a')) {
      api.createRecord('1f5b8a2a', component.options)
    } else {
      api.reload('1f5b8a2a', component.options)
    }
    module.hot.accept("./r-cell-config-table.vue?vue&type=template&id=1f5b8a2a", function () {
      api.rerender('1f5b8a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/cells/r-cell-config-table.vue"
export default component.exports